// extracted by mini-css-extract-plugin
export default {"txt1wrapper":"text_txt1wrapper__QfxrR","txt1":"text_txt1__bDATq"};